export enum CompanyUserStatusAction {
  ACTIVATE = 'Activate',
  DEACTIVATE = 'Deactivate',
}
